import * as React from 'react';
import { InformationalTooltip } from 'components/InformationalTooltip';
import { ArrowDownIcon, ArrowsUpDownIcon, ArrowUpIcon } from '@heroicons/react/20/solid';

interface Props {
  name: string;
  tooltip: string;
  showTooltip?: boolean;
  showSortArrows?: boolean;
  showSortDirectionArrow?: string;
  onSort?: () => void;
}

export const ColumnHeader: React.FC<Props> = (props) => {
  const { name, tooltip, showTooltip, showSortArrows, showSortDirectionArrow, onSort } = props;

  let arrowIcon = <ArrowsUpDownIcon className="w-4 h-4" />;
  if (showSortDirectionArrow === 'asc') {
    arrowIcon = <ArrowUpIcon className="w-4 h-4" />;
  } else if (showSortDirectionArrow === 'desc') {
    arrowIcon = <ArrowDownIcon className="w-4 h-4" />;
  }

  const sortButton = (
    <button
      type="button"
      className="p-1 text-sm text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-full"
      onClick={onSort}
    >
      {arrowIcon}
    </button>
  );

  return (
    <div className="MuiDataGrid-columnHeaderTitle px-2 py-4 gap-1 flex items-center">
      {name}
      {showSortArrows && sortButton}
      <InformationalTooltip show={showTooltip}>{tooltip}</InformationalTooltip>
    </div>
  );
};
ColumnHeader.displayName = 'ContainerTable.ColumnHeader';
